import { defineMessages } from 'react-intl';

const messages = defineMessages({
  selectLanguage: {
    id: 'localeSelector.selectLanguage',
    defaultMessage: 'Select Language',
  },
});

export default messages;
